<template>
  <div class="signup container">
    <v-card outlined>
      <v-card-title>회원 가입</v-card-title>
      <v-form @submit.prevent="signup" id="signup-form" class="px-4" lazy-validation>
        <v-text-field 
          class="text-field" label="필명" required outlined
          counter="10" :rules="nameRules" v-model="name"></v-text-field>
        <v-text-field 
          class="text-field" label="이메일" required outlined
          :rules="emailRules" v-model="email"></v-text-field>
        <v-text-field
          type="password" label="비밀번호" required outlined
          hint="6자 이상 입력해주세요" counter password v-model="password"></v-text-field>
        <p class="red--text" v-if="feedback">{{ feedback }}</p>
        <v-btn 
          type="submit" color="green" class="mb-5" outlined dark 
          form="signup-form" @click="signUp">가입하기</v-btn>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import slugify from 'slugify'
import db from '@/firebase/init'
import firebase from 'firebase'

export default {
  name: 'signup',
  data() {
    return {
      feedback: '',
      name: '',
      slug: '',
      nameRules: [
        v => !!v || '필명을 입력해주세요',
        v => (v && v.length <= 10) || '필명은 10자가 넘을 수 없어요'
      ],
      email: '',
      emailRules: [
        v => !!v || '이메일을 입력해주세요',
        v => /.+@.+\..+/.test(v) || '이메일 형식에 맞지 않습니다',
      ],
      password: ''
    }
  },
  methods: {
    signUp() {
      if(this.name && this.email && this.password) {
        this.slug = slugify(this.name, {
          replacement: '-',
          remove: /[!@#$%^&*()_+'"]/g,
          lower: true
        })
        let ref = db.collection('users').doc(this.slug)
        ref.get().then(doc => {
          if(doc.exists) {
            this.feedback = '죄송합니다. 이미 사용중인 필명입니다'
          } else {
            firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
              .then(creds => {
                ref.set({
                  name: this.name,
                  user_id: creds.user.uid
                })
              }).then(() => this.$router.push({ name: 'home' }))
              .catch(err => {
                console.log(err)
                this.feedback = err.message
              })
            this.feedback = ''
          }
        })
      } else {
        this.feedback = '모든 항목에 값을 입력해주세요'
      }
    }
  }
}
</script>

<style>
.signup {
  margin: 10vh auto;
  max-width: 50%;
}

.signup .text-field {
  margin: 5 auto !important;
}
</style>